const ZURICH_PLUM_PORTFOLIO_IDS = new Set<string>([
  'd2595249-314b-4383-8cae-1c23eda4c076',
  '4c9a6df5-f4ba-4907-8208-3da534a03586', 
]);

export function isZurichPlumHouseholdPortfolio(portfolioId: string, portfolioName: string): boolean {
  const id = portfolioId?.trim();
  if (id && ZURICH_PLUM_PORTFOLIO_IDS.has(id)) {
    return true;
  }
  const n = portfolioName?.trim().toLowerCase() ?? '';
  return n.startsWith('zurich plum household');
}